import React, { useEffect, useState } from 'react';
import Loader from '../../components/loader/loader';
import ProfileCard from '../../components/profile-card/profile-card';
import { useGetProfilesQuery, useSendProfileActionMutation } from '../../services/store/api/profiles';
import { TProfile, TProfilesFilters } from '../../types';
import Modal from '../../components/modal/modal';
import ProfilesFilter from '../../components/profiles-filter/profiles-filter';
import Heading from '../../components/heading/heading';
import styles from './profiles.module.css';
import WrapperEmpty from '../../components/wrapper/wrapper-empty';

export const ProfilesPage: React.FC = () => {
  const [page, setPage] = useState(1);
  const [code, setCode] = useState(0);

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [appliedFilters, setAppliedFilters] = useState<TProfilesFilters>({
    gender: undefined,
    goals: [],
    interests: [],
  });

  const [draftFilters, setDraftFilters] = useState<TProfilesFilters>(
    appliedFilters
  );

  const {
    data,
    isLoading,
  } = useGetProfilesQuery({ page, code, ...appliedFilters });

  const [sendAction, { isLoading: isSending }] =
    useSendProfileActionMutation();

  const [profiles, setProfiles] = useState<TProfile[]>([]);

  // Загружаем данные
  useEffect(() => {
    if (data?.profiles) {
      setProfiles(data.profiles);
    }
  }, [data]);

  // Удаляем по ID
  const handleDelete = (id: number) => {
    setProfiles(prev => prev.filter(p => p.id !== id));
  };

  const applyFilters = () => {
    setAppliedFilters(draftFilters);
    setPage(1);
    setIsFilterOpen(false);
  };

  useEffect(() => {
    if (profiles.length === 0) {
      setCode(new Date().getTime());
    }
  }, [profiles.length]);


  const handleAction = async (
    profileId: number,
    actionType: 'approve' | 'hide'
  ) => {
    try {
      await sendAction({ profileId, actionType }).unwrap();
      handleDelete(profileId);
    } catch (e) {
      console.error('Ошибка действия с профилем', e);
    }
  };

  const openFilters = () => {
    setDraftFilters(appliedFilters);
    setIsFilterOpen(true);
  };

  if (isLoading) {
    return <Loader />;
  }

  const currentProfile = profiles[0];

  const getActiveFiltersCount = (filters: TProfilesFilters): number => {
    let count = 0;
    if (filters.gender) count++;
    if (filters.age) count++;
    count += filters.goals.length;
    count += filters.interests.length;
    return count;
  }

  return (
    <>
      <Heading tpl="new">
        <div className="flex items-center justify-between">
          <div>
            Найди <span className="my-text-primary">своих</span>
          </div>
          <div>
            <button onClick={openFilters} className={styles.filter}>

              <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M3.25 8.125V9.20833H22.75V8.125H3.25ZM10.8333 17.875H15.1667V16.7917H10.8333V17.875ZM19.5 13.5417H6.5V12.4583H19.5V13.5417Z" fill="currentColor" />
              </svg>


              {getActiveFiltersCount(draftFilters) > 0 && (
                <span className="flex items-center justify-center w-5 h-5 
                     bg-white text-[#DD8560] text-xs font-bold 
                     rounded-full">
                  {getActiveFiltersCount(draftFilters)}
                </span>
              )}
            </button>
          </div>
        </div>
      </Heading>


      {profiles.length === 0 &&
        (
          <WrapperEmpty>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="w-16 h-16 mx-auto mb-4 text-gray-400" viewBox="0 0 16 16">
              <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
            </svg>
            <h3 className="text-xl font-semibold mb-2">Нет анкет для просмотра</h3>
            <p className="text-gray-600 mb-6">
              
            </p>
          </WrapperEmpty>
        )
      }

      {currentProfile &&
        <ProfileCard
          profile={currentProfile}
          onApprove={() =>
            handleAction(currentProfile.id, 'approve')
          }
          onHide={() =>
            handleAction(currentProfile.id, 'hide')
          }
          isProcessing={isSending}
        />
      }


      {isFilterOpen && (
        <Modal
          key="profiles-filter-modal"
          header="Параметра поиска"
          size="LARGENS"
          onClose={() => setIsFilterOpen(false)}
        >
          <ProfilesFilter
            value={draftFilters}
            onChange={setDraftFilters}
            onApply={applyFilters}
            onReset={() =>
              setDraftFilters({
                gender: undefined,
                goals: [],
                interests: [],
                age: undefined
              })
            }
            isOpen={isFilterOpen}
          />
        </Modal>
      )}

    </>
  );
};


